import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const base =
  'inline-flex items-center justify-center gap-2 rounded-lg px-4 min-h-[44px] text-sm ' +
  'font-medium transition-colors disabled:opacity-50 disabled:pointer-events-none ' +
  'focus:outline-none focus:ring-2 focus:ring-pine focus:ring-offset-1';

const variants: Record<Variant, string> = {
  primary: 'bg-pine text-white hover:bg-pine-600 active:bg-pine-800',
  secondary: 'border border-slate-300 bg-surface text-ink hover:bg-slate-50',
  ghost: 'text-pine hover:bg-slate-100',
  danger: 'bg-danger text-white hover:brightness-95'
};

/** Pack B button primitive — tokenized (pine primary), 44px min touch target. */
export function Button({
  variant = 'primary',
  className = '',
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; children: ReactNode }) {
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
